import { Reveal, SectionHeading } from "@/components/Reveal";
import { useLang } from "@/i18n/translations";

export const Process = () => {
  const { t } = useLang();
  return (
    <section id="prozess" data-testid="process-section" className="relative py-20 sm:py-28 bg-[#05070d]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-10">
        <SectionHeading kicker={t.process.kicker} title={t.process.title} subtitle={t.process.subtitle} testId="process-heading" />
        <div className="mt-14 relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-[#00d4ff]/40 via-white/10 to-transparent hidden sm:block" aria-hidden="true" />
          <ol className="space-y-8">
            {t.process.steps.map((step, i) => (
              <li key={i} data-testid={`process-step-${i + 1}`} className="relative sm:pl-16">
                <Reveal delay={i * 0.05}>
                  <span className="hidden sm:flex absolute left-0 top-0 w-10 h-10 rounded-full border border-[#00d4ff]/30 bg-[#070a12] items-center justify-center text-[11px] font-mono-cs text-[#00d4ff]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="rounded-xl border border-white/10 bg-white/[0.02] px-6 py-5 hover:border-white/20 transition-[border-color] duration-300">
                    <h3 className="font-display text-lg font-semibold text-foreground">
                      <span className="sm:hidden font-mono-cs text-[#00d4ff] text-xs mr-2">{String(i + 1).padStart(2, "0")}</span>
                      {step.title}
                    </h3>
                    <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{step.text}</p>
                  </div>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
